import { render, staticRenderFns } from "./MyGroups.vue?vue&type=template&id=5d711ba1&scoped=true&"
import script from "./MyGroups.vue?vue&type=script&lang=js&"
export * from "./MyGroups.vue?vue&type=script&lang=js&"
import style0 from "../admin/minds.css?vue&type=style&index=0&lang=css&"
import style1 from "../learning.css?vue&type=style&index=1&lang=css&"
import style2 from "./MyGroups.vue?vue&type=style&index=2&id=5d711ba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d711ba1",
  null
  
)

export default component.exports